import React from "react";
import ReactDOM from "react-dom/client";

import "./assets/css/style.css";
import "./assets/css/responsive.css"
import App from "./App";
import reportWebVitals from "../src/reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
